export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "pending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'avis de l'agent sera disponible une fois toutes les analyses de documents terminées."])},
        "unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avis de l'agent indisponible"])},
        "retry_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relancer l'analyse"])},
        "retried": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Analyse relancée : l'avis sera mis à jour dans quelques minutes."])},
        "show_full_analysis": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir l'analyse complète"])},
        "hide_full_analysis": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Masquer l'analyse complète"])}
      },
      "en": {
        "pending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The agent's opinion will be available once every document analysis is done."])},
        "unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agent opinion unavailable"])},
        "retry_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retry analysis"])},
        "retried": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Analysis restarted: the opinion will be updated in a few minutes."])},
        "show_full_analysis": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show the full analysis"])},
        "hide_full_analysis": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hide the full analysis"])}
      }
    }
  })
}
